/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: false
	},
};

(function() {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;

		if (data.product_type != 'PPLR_HIDDEN_PRODUCT') {
			
			/*** Prepare data ***/
			var images = data.images_info;
			var tags = data.tags;
			// Displaying price base on the policy of Shopify, have to multiple by 100
			var soldOut = !data.available; // Check a product is out of stock
			var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
			var priceVaries = data.price_min != data.price_max; // Check a product has many prices
			// Get First Variant (selected_or_first_available_variant)
			var firstVariant = data['variants'][0];
			if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
				var paramVariant = data.variants.filter(function(e) {
					return e.id == Utils.getParam('variant');
				});
				if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
			} else {
				for (var i = 0; i < data['variants'].length; i++) {
					if (data['variants'][i].available) {
						firstVariant = data['variants'][i];
						break;
					}
				}
			}
			/*** End Prepare data ***/
	
			// Get Template
			var itemHtml = boostPFSTemplate.productGridItemHtml;
	
			// Add soldOut class
			var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
			itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);
	
			// Add soldOut label
			var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
			itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
	
			// Add image
			if (images.length > 0) {
				var itemImageHtml = `<img class="product-card-image lazyload" data-src="${Utils.getFeaturedImage(images, '500x')}">`;
				itemHtml = itemHtml.replace(/{{itemImage}}/g, itemImageHtml);
			} else {
				itemHtml = itemHtml.replace(/{{itemImage}}/g, '');
			}
	
			// Add badge
			var itemBadgeHtml = getBadge(tags, onSale);
			itemHtml = itemHtml.replace(/{{itemBadge}}/g, itemBadgeHtml);
	
			// Add Vendor
			// var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
			var itemVendorHtml = boostPFSTemplate.vendorGridHtml;
			itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
	
			// Add Price
			var itemPriceHtml = buildPrice(data, onSale, priceVaries);
			itemHtml = itemHtml.replace(/{{itemPrice}}/g, data.template_suffix != "total-look" ? itemPriceHtml : '');
	
			// Add main attribute
			itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
			itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
			itemHtml = itemHtml.replace(/{{itemVendorLink}}/g, buildVendorLink(theme.Handleize(data.vendor)));
			itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
	
			return itemHtml;
        } else {
          	return '';
        }
		
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, data.template_suffix != "total-look" ? itemPriceHtml : '');

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = data.available && onSale ? ' price--on-sale' : '';
			soldOutClass = data.available ? '' : ' price--sold-out'
	
		priceHtml += '<dl class="price' + onSaleClass + ' ' + soldOutClass + '" data-price>';
		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
		if (data.available) {
			if (onSale) {
				priceHtml += `${Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat)}`;
			} else {
				priceHtml += `${Utils.formatMoney(data.price_min, Globals.moneyFormat)}`;
			}
		} else {
			priceHtml += boostPFSConfig.label.sold_out;
		}
		priceHtml += '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '<div class="price__sale">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
		priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		priceHtml += '</span> ';
		// priceHtml += '<span class="price-item__label" aria-hidden="true">' + boostPFSConfig.label.sale + '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '</dl>';
	
		return priceHtml;
	}

	function buildVendorLink(vendor) {
		return window.allCollections.includes(vendor) ? `href="/collections/${vendor}"` : ''
	}

	function getBadge(tagsArray, onSale) {

		const tags = tagsArray.map(tag => tag.toLowerCase());

		let badge = '';

		if (tags.includes('new')) {
			badge = 'NEW';
		} else if (onSale) {
			badge = 'SALE';
		} else if (tags.includes('special edition')) {
			badge = 'SPECIAL EDITION';
		} else if (tags.includes('staff pick')) {
			badge = 'STAFF PICK';
		} else if (tags.includes('best seller')) {
			badge = 'BEST SELLER';
		} else if (tags.includes('limited edition')) {
			badge = 'LIMITED EDITION';
		}

		if (badge != '') {
			const badgeClass = badge.toLowerCase().replace(' ', '-');

			return `<span class="product-card-badge ${badgeClass}">${badge}</span>`;
		}

		return '';
	}

		// Build Pagination
		ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
			if (!totalProduct) totalProduct = this.totalProduct;
			// Get page info
			var currentPage = parseInt(Globals.queryParams.page);
			var totalPages = Math.ceil(totalProduct / Globals.queryParams.limit);
			
			// If it has only one page, clear Pagination
			if (totalPages <= 1) {
				return '';
			}
		
			if (Settings.getSettingValue('general.paginationType') == 'default') {
				var paginationHtml = boostPFSTemplate.paginateHtml;
		
				// Build Previous
				var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
				previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
				paginationHtml = paginationHtml.replace(/{{previous}}/g, currentPage == 1 ? '' : previousHtml);
		
				// Build Next
				var nextHtml = (currentPage < totalPages) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
				nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
				paginationHtml = paginationHtml.replace(/{{next}}/g, currentPage == totalPages ? '' : nextHtml);

				// [(+)] ++++++++ BUILD INDIVIDUAL PAGES ++++++++ [(+)]
				var pageIteration = '';
				var maximumPages = (currentPage + 1);

				for (let i = 0; i <= totalPages; i++) {
					if (i > 0 && i < currentPage && i > (totalPages - 3)) {
						pageIteration += `<li class="grid-pagination-link ${(currentPage === i) ? 'current' : ''}"><a href="${Utils.buildToolbarLink('page', currentPage, i)}">${i}</a></li>`;
					}

					if (currentPage == i) {
						pageIteration += `<li class="grid-pagination-link current"><a href="${Utils.buildToolbarLink('page', currentPage, i)}">${i}</a></li>`;
					}

					if (i <= maximumPages && i < totalPages && i > currentPage) {
						pageIteration += `<li class="grid-pagination-link"><a href="${Utils.buildToolbarLink('page', currentPage, i)}">${i}</a></li>`;
					}
				}

				if (currentPage != totalPages) {
					pageIteration += `<li class="grid-pagination-link disabled"><a>-</a></li><li class="grid-pagination-link"><a href="${Utils.buildToolbarLink('page', currentPage, totalPages)}">${totalPages}</a></li>`;
				}

				paginationHtml = paginationHtml.replace(/{{individualPages}}/g, pageIteration);
		
				return paginationHtml;
			}
		};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			// productSelector.addClass('grid grid--uniform grid--view-items');
		}

		const titles = document.querySelectorAll('.product-card-title');
    const vendors = document.querySelectorAll('.product-card-vendor');

    const gridOptions = [
      {
        breakpoint: 1440,
        columns: 3,
      },
      {
        breakpoint: 960,
        columns: 2,
      },
      {
        breakpoint: 640,
        columns: 1,
      },
    ];

    window.alignProductCardInfo(titles, '--height-title', gridOptions);
    window.alignProductCardInfo(vendors, '--height-vendor', gridOptions);
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};
})();